import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "选择报价方案", -1)
const _hoisted_2 = {
  key: 0,
  class: "text-grey ml10"
}

export function render(_ctx, _cache) {
  const _component_a_input_search = _resolveComponent("a-input-search")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_form = _resolveComponent("a-form")
  const _component_table_wrapper = _resolveComponent("table-wrapper")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", {
      onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.showModal && _ctx.showModal(...args)))
    }, "从预算报价导入"),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = $event => ((_ctx.visible) = $event)),
      width: "1000px",
      keyboard: false,
      centered: true,
      "mask-closable": false,
      onOk: _ctx.ok,
      onCancel: _ctx.closeModal
    }, {
      title: _withCtx(() => [
        _hoisted_1,
        (_ctx.needProjectId)
          ? (_openBlock(), _createElementBlock("small", _hoisted_2, "仅展示已选项目下的报价方案"))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "inline" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_search, {
                  value: _ctx.queryRef.skillSolutionBizNo,
                  "onUpdate:value": _cache[1] || (_cache[1] = $event => ((_ctx.queryRef.skillSolutionBizNo) = $event)),
                  valueModifiers: { trim: true },
                  placeholder: "请输入报价方案编号",
                  style: {"width":"250px"},
                  "enter-button": "",
                  "allow-clear": "",
                  loading: _ctx.loading,
                  onSearch: _ctx.search
                }, null, 8, ["value", "loading", "onSearch"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_table_wrapper, {
          dataSource: _ctx.dataSource,
          onOnTableChange: _ctx.onTableChange,
          onOnSelectionChange: _ctx.onSelectionChange,
          pagination: _ctx.pagination,
          loading: _ctx.loading,
          columns: _ctx.columns
        }, {
          totalBudget: _withCtx(({ record }) => [
            _createTextVNode(_toDisplayString(_ctx.$filters.formatMoney(record.totalBudget)), 1)
          ]),
          _: 1
        }, 8, ["dataSource", "onOnTableChange", "onOnSelectionChange", "pagination", "loading", "columns"])
      ]),
      _: 1
    }, 8, ["visible", "onOk", "onCancel"])
  ], 64))
}